// @flow

import React from 'react'
import Appear from './Appear'
import Container from './Container'
import SectionTitle from './SectionTitle'
import { markdown } from 'markdown'
import type { Image as ImageType } from 'types/'
import Image from 'components/Image'

type Props = {
  title: string,
  text: String,
  image: ImageType
}

const Congres = ({ title, text, image }: Props) => {
  return (
    <div className="bg-light-blue">
      <div className="relative">
        <Appear>
          <Image image={image} alt="" />
        </Appear>
        <div className="absolute top-0 left-0 right-0">
            <SectionTitle title={title} white />
        </div>
      </div>
      <div className="xl:-mt-16">
        <Appear>
          <Container className="pb-16">
          <div key="content" className="flex-1 pb-12 bg-white shadow-xl md:pb-8">
          <Appear>
            <div className="h-4 bg-white border-b-4 border-dashed border-light-blue" />
            <div className="px-5 pt-8 pb-2 md:pl-8 md:pr-24">
              {text && 
                <div className="flex-1 block mb-3 text-base font-light md:text-lg congresText innerStrongBlue" dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }}/>
              }
            </div>
          </Appear>         
          </div>
          </Container>
        </Appear>
      </div>
    </div>
  )
}

export default Congres
